import AddressesPage from "../../pages/legacy/addresses/AddressesPage";

const route = {
  key: "addresses",
  path: "/legacy/addresses",
  component: AddressesPage,
  private: true,
  layout: "main",
  icon: "faLocationDot",
  group: "masterdata",
  order: 10,
  permission: "legacy.addresses.read"
};

export default route;